import { render, staticRenderFns } from "./CardChallengesHeader.vue?vue&type=template&id=fbfc7a38&"
import script from "./CardChallengesHeader.vue?vue&type=script&lang=js&"
export * from "./CardChallengesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports